import {useContext} from 'react'
import {FloatContainerContext} from '../../helpers/context'

const NotificationItemTemplate = ({className, unread, graphic, title, caption, time}) => {
  const {setActive} = useContext(FloatContainerContext)
  return (
    <article
      onClick={() => setActive(false)}
      className={`notification-item ${className} ${unread && 'unread'}`}
    >
      {graphic}
      <div>
        <p className="caption">
          {title && <span className="title">{title} </span>}
          {caption}
        </p>
        <time className="time">{time}</time>
      </div>
    </article>
  )
}

export default NotificationItemTemplate
